const storagePrefix = 'modtools_auditlog_input_size_'
const observers = new WeakMap()

function storageKey (value) {
  return storagePrefix + String(value || 'default').replace(/[^A-Za-z0-9_-]/g, '_')
}

export const auditLogResizeDirective = {
  inserted (element, binding) {
    element.style.resize = 'both'
    element.style.overflow = 'auto'
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey(binding.value)) || 'null')
      if (stored && stored.width > 0 && stored.height > 0) {
        element.style.width = `${stored.width}px`
        element.style.height = `${stored.height}px`
      }
    } catch (error) {
      // Ignore malformed or unavailable local storage.
    }
    if (!window.ResizeObserver) {
      return
    }
    const observer = new window.ResizeObserver(entries => {
      const rect = entries[0] && entries[0].contentRect
      if (!rect || rect.width <= 0 || rect.height <= 0) {
        return
      }
      try {
        localStorage.setItem(storageKey(binding.value), JSON.stringify({
          width: Math.round(element.offsetWidth),
          height: Math.round(element.offsetHeight)
        }))
      } catch (error) {
        // Resizing must continue to work when local storage is unavailable.
      }
    })
    observer.observe(element)
    observers.set(element, observer)
  },
  unbind (element) {
    const observer = observers.get(element)
    if (observer) {
      observer.disconnect()
      observers.delete(element)
    }
  }
}
